import { SET_HOMES } from "@/constants/action-home-types";

// Summaries of all properties the user owns (multi-home). state.Home stays the
// active property; this slice only powers the hub + the switcher list.
export interface HomeSummary {
  _id: number;
  name?: string;
  address?: string;
  city?: string;
  zone?: string;
  profile_image?: string;
  cover?: string;
  n_rooms?: number;
  n_ads?: number;
  active?: boolean;
}

type HomesState = HomeSummary[];

const initialState: HomesState = [];

export default function homesReducer(
  state: HomesState = initialState,
  action: { type: string; payload?: any }
): HomesState {
  switch (action.type) {
    case SET_HOMES:
      return Array.isArray(action.payload) ? action.payload : [];
    default:
      return state;
  }
}
